<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-12 14:54:39
-->
<template>
  <div class="container-view-slot">
    <!-- 内容插槽 -->
    <div class="container-content">
      <slot></slot>
    </div>
    <!-- 底部导航 -->
    <div class="tab-ls-wrap">
      <div
        v-for="ele in newTabs"
        :key="ele.name"
        @click="
          !$route.fullPath.includes(ele.linkTo) && $router.push(ele.linkTo)
        "
        :class="['tab-item', { active: $route.fullPath.includes(ele.linkTo) }]"
        :title="ele.name"
      >
        {{ ele.name }}
      </div>
    </div>
    <!-- <div class="technical-support">技术支持：优鱼（广州）技术有限公司</div> -->
  </div>
</template>

<script>
export default {
  name: "overview-tab",
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    newTabs() {
      return this.tabs.filter((item) => item.flag);
    },
  },
  methods: {},
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    // window.initBaiduMapScript = () => {
    //   this.mapHandle();
    // };
    // loadBMap("initBaiduMapScript");
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    "$store.state.app.menuFlag": {
      immediate: true,
      deep: true,
      handler(curVal, oldVal) {
        const name = this.$route.name;
        if (name.indexOf("day-") > -1) {
          this.tabs = [
            // {
            //   name: "育苗",
            //   linkTo: "/day/ym",
            //   flag: curVal.middleDayYmFlag,
            // },
            {
              name: "养成",
              linkTo: "/day/yc",
              flag: curVal.middleDayYcFlag,
            },
          ];
        } else if (name.indexOf("month-") > -1) {
          this.tabs = [
            // {
            //   name: "育苗",
            //   linkTo: "/month/ym",
            //   flag: curVal.middleMonthYmFlag,
            // },
            {
              name: "养成",
              linkTo: "/month/yc",
              flag: curVal.middleMonthYcFlag,
            },
          ];
        } else {
          this.tabs = [
            // {
            //   name: "育苗",
            //   linkTo: "/ym",
            //   flag: curVal.presidentYmFlag,
            // },
            {
              name: "养成",
              linkTo: "/yc",
              flag: curVal.presidentYcFlag,
            },
          ];
        }
      },
    },
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
@tab-height: 61px;
.container-view-slot {
  width: 100%;
  height: 100%;
  position: relative;
  .technical-support {
    position: absolute;
    bottom: 12px;
    right: 60px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
}
// 内容盒子
.container-content {
  height: calc(100% - @tab-height);
  overflow-y: auto;

  /*滚动条整体样式*/
  &::-webkit-scrollbar {
    width: 0.5rem;
    background-color: #181a1f;
  }
  /*滚动条里面小方块*/
  &::-webkit-scrollbar-thumb {
    background: #383848;
    border-radius: 0.5rem;
    height: 0.5rem;
  }
  // /*滚动条里面轨道*/
  &::-webkit-scrollbar-track {
    background: #48485a;
    border-radius: 20rem;
  }
}
// 底部导航
.tab-ls-wrap {
  height: @tab-height;
  background: #232231;
  box-shadow: 0px 2px 8px 0px #1b1a27;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;

  &::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 1px;
    background-color: #2f333b;
  }

  .tab-item {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #d1e2f4;
    line-height: @tab-height;

    &:hover,
    &.active {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #2aedff;
    }
    &:not(:first-child) {
      margin-left: 82px;
    }
  }
}
</style>